import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useIntersectionObserver } from "./hooks/useIntersectionObserver";
import { changeLanguageAndPersist } from "./i18n";
import "./App.css";
import logoImage from "./assets/logo.png";
import tozKarbonImage from "./assets/toz_karbon.png";
import granulKarbonImage from "./assets/granul_karbon.png";
import bioKarbonImage from "./assets/bio_karbon.png";
import { analytics } from "./firebaseconfig";
import { logEvent } from "firebase/analytics";

function App() {
  const { t, i18n } = useTranslation();
  const [menuAcik, setMenuAcik] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const anasayfaRef = useRef(null);
  const hakkimizdaRef = useRef(null);
  const uygulamalarRef = useRef(null);
  const iletisimRef = useRef(null);

  const hakkimizdaVisible = useIntersectionObserver(hakkimizdaRef, {
    threshold: 0.1,
  });
  const uygulamalarVisible = useIntersectionObserver(uygulamalarRef, {
    threshold: 0.1,
  });
  const iletisimVisible = useIntersectionObserver(iletisimRef, {
    threshold: 0.1,
  });

  const scrollToSection = (ref) => {
    const navbarHeight = document.querySelector(".navbar").offsetHeight;
    const elementPosition = ref.current.offsetTop - navbarHeight;
    window.scrollTo({
      top: elementPosition,
      behavior: "smooth",
    });
    setMenuAcik(false);
  };

  useEffect(() => {
    logEvent(analytics, "page_view");
    const handleScroll = () => {
      // İlk bölümün yüksekliğini geçince butonu göster
      setShowScrollTop(window.scrollY > window.innerHeight);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    let handleClick;
    const setupAccordions = () => {
      const accordionButtons = document.querySelectorAll(".accordion-button");

      if (accordionButtons.length === 0) {
        setTimeout(setupAccordions, 500);
        return;
      }

      document.querySelectorAll(".accordion-content").forEach((content) => {
        content.style.maxHeight = "0px";
        content.style.padding = "0";
        content.style.overflow = "hidden";
      });

      handleClick = function () {
        this.classList.toggle("active");
        const content = this.nextElementSibling;
        if (
          content.style.maxHeight !== "0px" &&
          content.style.maxHeight !== ""
        ) {
          content.style.maxHeight = "0px";
          content.style.padding = "0";
          this.querySelector(".accordion-icon").textContent = "+";
        } else {
          content.style.maxHeight = content.scrollHeight + 40 + "px";
          content.style.padding = "20px";
          this.querySelector(".accordion-icon").textContent = "×";
        }
      };

      accordionButtons.forEach((button) => {
        button.removeEventListener("click", handleClick);
        button.addEventListener("click", handleClick);
      });
    };

    setupAccordions();

    return () => {
      const accordionButtons = document.querySelectorAll(".accordion-button");
      accordionButtons.forEach((button) => {
        if (handleClick) button.removeEventListener("click", handleClick);
      });
    };
  }, [i18n.language]);

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-container">
          <div className="logo">
            <img src={logoImage} alt="BionCarbon Logo" />
            <span>BionCarbon</span>
          </div>
          <button
            className="menu-toggle"
            onClick={() => setMenuAcik(!menuAcik)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <div className={`nav-links ${menuAcik ? "active" : ""}`}>
            <button onClick={() => scrollToSection(anasayfaRef)}>
              {t("nav.home")}
            </button>
            <button onClick={() => scrollToSection(hakkimizdaRef)}>
              {t("nav.about")}
            </button>
            <button onClick={() => scrollToSection(uygulamalarRef)}>
              {t("nav.products")}
            </button>
            <button onClick={() => scrollToSection(iletisimRef)}>
              {t("nav.contact")}
            </button>
            <div className="lang-toggle">
              <button
                type="button"
                className={i18n.language === "tr" ? "active" : ""}
                onClick={() => changeLanguageAndPersist("tr")}
                aria-label="Türkçe"
              >
                TR
              </button>
              <button
                type="button"
                className={i18n.language === "en" ? "active" : ""}
                onClick={() => changeLanguageAndPersist("en")}
                aria-label="English"
              >
                EN
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="hero-section" ref={anasayfaRef}>
        <div className="hero-overlay">
          <img src={logoImage} alt="BionCarbon" className="hero-logo" />
          <h1>
            <span className="bion">Bion</span>
            <span className="carbon">Carbon</span>
          </h1>
          <h2 className="hero-slogan">{t("hero.slogan")}</h2>
        </div>
      </div>

      <div
        className={`section fade-in ${hakkimizdaVisible ? "visible" : ""}`}
        ref={hakkimizdaRef}
      >
        <h1>{t("about.title")}</h1>
        <p>{t("about.paragraph1")}</p>
        {/*<div className="hakkimizda-image-container">
          <img
            src="https://bioenergyinternational.com/wp-content/uploads/sites/3/2024/06/chartech.jpg"
            alt={t("about.imageAlt")}
            className="hakkimizda-image"
          />
          <div className="hakkimizda-image-overlay"></div>
        </div>*/}
        <p>{t("about.paragraph2")}</p>
        <p>{t("about.paragraph3")}</p>
        <p>{t("about.paragraph4")}</p>
      </div>

      <div
        className={`section uygulamalar-section fade-in ${
          uygulamalarVisible ? "visible" : ""
        }`}
        ref={uygulamalarRef}
      >
        <h1>{t("products.title")}</h1>
        <div className="uygulamalar-grid">
          <div
            className={`uygulama-card ${uygulamalarVisible ? "visible" : ""}`}
            style={{ animationDelay: "0.2s" }}
          >
            <img
              src={tozKarbonImage}
              alt={t("products.powder.title")}
              className="uygulama-image"
            />
            <h3>{t("products.powder.title")}</h3>
            <p>{t("products.powder.description")}</p>
          </div>
          <div
            className={`uygulama-card ${uygulamalarVisible ? "visible" : ""}`}
            style={{ animationDelay: "0.4s" }}
          >
            <img
              src={granulKarbonImage}
              alt={t("products.granular.title")}
              className="uygulama-image"
            />
            <h3>{t("products.granular.title")}</h3>
            <p>{t("products.granular.description")}</p>
          </div>
          <div
            className={`uygulama-card ${uygulamalarVisible ? "visible" : ""}`}
            style={{ animationDelay: "0.6s" }}
          >
            <img
              src={bioKarbonImage}
              alt={t("products.bio.title")}
              className="uygulama-image"
            />
            <h3>{t("products.bio.title")}</h3>
            <p>{t("products.bio.description")}</p>
          </div>
        </div>
      </div>

      <div className="section accordion-section fade-in-visible">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/bioncarbon.firebasestorage.app/o/slogan_icon.png?alt=media&token=50afbca4-3e64-43b4-9f42-83f42dbd151f"
          alt={t("accordion.sloganAlt")}
          className="slogan-icon"
        />
        <h2 className="slogan-text">
          <i>
            {t("accordion.sloganText")}{" "}
            <span className="highlight-green">{t("accordion.sloganHighlight")}</span>{" "}
            {t("accordion.sloganTextEnd")}
          </i>
        </h2>
        <div className="accordion-container" key={i18n.language}>
          <div className="accordion-item">
            <button className="accordion-button">
              {t("accordion.whatIsActiveCarbon.title")}
              <span className="accordion-icon">+</span>
            </button>
            <div className="accordion-content">
              <p>{t("accordion.comingSoon")}</p>
            </div>
          </div>

          <div className="accordion-item">
            <button className="accordion-button">
              {t("accordion.whyBioncarbon.title")}
              <span className="accordion-icon">+</span>
            </button>
            <div className="accordion-content">
              <p>{t("accordion.comingSoon")}</p>
            </div>
          </div>

          <div className="accordion-item">
            <button className="accordion-button">
              {t("accordion.productionCapacity.title")}
              <span className="accordion-icon">+</span>
            </button>
            <div className="accordion-content">
              <p>{t("accordion.comingSoon")}</p>
            </div>
          </div>

          <div className="accordion-item">
            <button className="accordion-button">
              {t("accordion.sustainability.title")}
              <span className="accordion-icon">+</span>
            </button>
            <div className="accordion-content">
              <p>{t("accordion.comingSoon")}</p>
            </div>
          </div>

          <div className="accordion-item">
            <button className="accordion-button">
              {t("accordion.qualityControl.title")}
              <span className="accordion-icon">+</span>
            </button>
            <div className="accordion-content">
              <p>{t("accordion.comingSoon")}</p>
            </div>
          </div>

          <div className="accordion-item">
            <button className="accordion-button">
              {t("accordion.competitivePricing.title")}
              <span className="accordion-icon">+</span>
            </button>
            <div className="accordion-content">
              <p>{t("accordion.comingSoon")}</p>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`section iletisim-section fade-in ${
          iletisimVisible ? "visible" : ""
        }`}
        ref={iletisimRef}
      >
        <h1>{t("contact.title")}</h1>
        <div className="iletisim-container">
          <div className="iletisim-bilgileri">
            <div className="iletisim-kart">
              <i className="fas fa-map-marker-alt"></i>
              <div>
                <h3>{t("contact.address")}</h3>
                <p>
                  Seyitahmet Mah. Organize Sanayi Bölgesi No:40
                  <br />
                  Beşikdüzü/Trabzon
                </p>
              </div>
            </div>

           {/* <div className="iletisim-kart">
              <i className="fas fa-phone"></i>
              <div>
                <h3>{t("contact.phone")}</h3>
                <p>{t("contact.phoneNumber")}</p>
              </div>
            </div>*/}

            <a
              href="mailto:info@bioncarbon.com"
              className="iletisim-kart iletisim-kart-link"
            >
              <i className="fas fa-envelope"></i>
              <div>
                <h3>{t("contact.email")}</h3>
                <p>info@bioncarbon.com</p>
              </div>
            </a>
          </div>
        </div>

       {/* <div className="iletisim-form-container">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSeJf9nIUzuw2dHZJ3u8Z0wlHndUl0Aqdv76mQw2M_OFnlVYvg/viewform?embedded=true"
            width="500"
            height="1000"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title={t("contact.formTitle")}
            style={{ maxWidth: "100%", overflow: "hidden" }}
          >
            {t("contact.formLoading")}
          </iframe>
        </div>*/}

        <div className="sosyal-medya">
          <a
            href="https://maps.app.goo.gl/8HnU4oJ3fz84WgFw9"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-google"></i>
          </a>
          <a
            href="https://www.linkedin.com/company/bioncarbon"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
        </div>
      </div>

      <button
        className={`scroll-to-top ${showScrollTop ? "visible" : ""}`}
        onClick={scrollToTop}
        aria-label={t("aria.scrollTop")}
      >
        <i className="fas fa-arrow-up"></i>
      </button>
    </div>
  );
}

export default App;
